module.exports = __webpack_public_path__ + "static/media/sn_h_vk.ae5d1502.svg";